import defaultState from './state';

const SAVE_CURRENT_ASSIGNMENT_DETAILS = (state, details) => {
  state.currentAssignmentDetails = details;
};

export default {
  SAVE_CURRENT_ASSIGNMENT_DETAILS
};



// WEBPACK FOOTER //
// ./src/store/modules/assignments/mutations.js